export enum ChartType {
  BPM = 'bpm',
  VO2 = 'vo2',
  VE = 've',
  BR = 'br',
}
